/**
 * 
 * @param {Number} min 
 * @param {Number} max 
 * @param {Number} length
 * @returns {Array<Number>}
 * @description Retorna un array de números aleatorios entre min y max
 */
export default function getRandomNumbersArrayBetween(min, max, length) {
    const array = [];
    for (let i = 0; i < length; i++) {
        array.push(Math.floor(Math.random() * (max - min + 1)) + min);
    }
    return array;
}